import { Box, Link as MuiLink, Tooltip } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { Link } from "react-router-dom";
import { entityDetailUrl } from "./importEntityLinks";

const styles = {
  id: {
    fontFamily: "monospace",
    fontSize: "0.78rem",
  },
  empty: {
    color: "text.disabled",
  },
};

export default function GeneratedIdCell({
  jobDataType,
  generatedId,
}: Readonly<{ jobDataType?: string; generatedId?: string }>) {
  const urls = useGlobalContext();

  if (!generatedId) {
    return <Box sx={{ ...styles.id, ...styles.empty }}>&mdash;</Box>;
  }

  const truncated = `${generatedId.slice(0, 8)}…`;
  const href = entityDetailUrl(urls, jobDataType, generatedId);

  if (!href) {
    return (
      <Tooltip title={generatedId}>
        <Box component="span" sx={styles.id}>
          {truncated}
        </Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={generatedId}>
      <MuiLink component={Link} to={href} sx={styles.id}>
        {truncated}
      </MuiLink>
    </Tooltip>
  );
}
